import { UpdateCanvasView } from "../types/editor-action.types";

export interface Params {
  canvasWidth: number;
  canvasHeight: number;
  canvasViewX: number;
  canvasViewY: number;
  nodeWidth: number;
  nodeHeight: number;
  nodeX: number;
  nodeY: number;
}

const OFFSET = 25;

export function createActionToMoveNodeIntoView(
  params: Params
): UpdateCanvasView | undefined {
  const canvasX1 = params.canvasViewX;
  const canvasY1 = params.canvasViewY;
  const canvasX2 = canvasX1 + params.canvasWidth;
  const canvasY2 = canvasY1 + params.canvasHeight;

  const nodeX1 = params.nodeX;
  const nodeY1 = params.nodeY;
  const nodeX2 = nodeX1 + params.nodeWidth;
  const nodeY2 = nodeY1 + params.nodeHeight;

  let newCanvasX1 = canvasX1;
  let newCanvasY1 = canvasY1;

  const canMakeFullyVisibleX = params.nodeWidth + OFFSET <= params.canvasWidth;
  const isFullyInvisibleX = nodeX1 > canvasX2 || nodeX2 < canvasX1;
  const shouldChangeX = canMakeFullyVisibleX || isFullyInvisibleX;

  if (shouldChangeX) {
    if (nodeX1 < canvasX1) {
      newCanvasX1 = params.nodeX - OFFSET;
    } else if (nodeX2 > canvasX2) {
      newCanvasX1 = nodeX2 - params.canvasWidth + OFFSET;
    }
  }

  if (nodeY1 < canvasY1) {
    newCanvasY1 = params.nodeY - OFFSET;
  } else if (nodeY2 > canvasY2) {
    newCanvasY1 = nodeY2 - params.canvasHeight + OFFSET;
  }

  if (newCanvasX1 !== canvasX1 || newCanvasY1 !== canvasY1) {
    return {
      type: "UPDATE_CANVAS_VIEW",
      view: {
        x: newCanvasX1,
        y: newCanvasY1,
      },
    };
  }
}
